/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type KiteAnalyticsNewAccountRequest = {
    period?: KiteAnalyticsNewAccountRequest.period;
};

export namespace KiteAnalyticsNewAccountRequest {

    export enum period {
        D7 = 'D7',
        D30 = 'D30',
        D90 = 'D90',
        ALL = 'ALL',
    }


}

